import { styled } from 'src/styles/stitches.config'

export const Wrapper = styled('div', {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: '$background',
    zIndex: '9999',
})

export const Loader = styled('div', {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '0px',
    height: '1px',
    backgroundColor: '#fff',
})
